import React from 'react';
import { Mail, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = ({ language }) => {
  const texts = {
    en: {
      company: '365FullPull',
      tagline: 'Your destination for mobile games and apps',
      quickLinks: 'Quick Links',
      support: 'Support',
      legal: 'Legal',
      contact: 'Contact Us',
      address: 'Slovenia',
      email: 'support@365fullpull.com',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
      cookies: 'Cookies',
      home: 'Home',
      features: 'Features',
      howItWorks: 'How It Works',
      games: 'Games',
      disclaimer: 'This service includes subscription to Adsaints. You will receive a personal SMS on the website or by reply and by confirming via SMS you agree and confirm the use of services as well as receiving the latest coolest mobile content (text content, ringtones, wallpapers, Java games). The service price is EUR 4.98 per week (2 SMS per week at 2.49 EUR with VAT). You can unsubscribe from the service by sending Clicksaints STOP NOW to 3838. Each week you will receive 1 new content. The service will be charged to your mobile account or to your prepaid account. Your device must have enabled receiving text messages, data transfer and receiving mobile content. The company Clicksaints is not affiliated with or sponsored by the manufacturers of products that are mentioned or can be seen in this campaign. Trademarks, service marks, logos (including, but not limited to) individual product names and retail sellers are the property of their original owners. To use the services you must be the owner of the subscription relationship or obtain explicit permission from the owner, in case of minors you must obtain explicit permission from parents or guardians. For information call 016001850 (Monday-Friday 09:00-17:00), adsaints.si@silverlines.info. Adsaints B.V., Wim Duisenbergplantsoen 31, 6221 SE, Maastricht, Holland.'
    },
    sl: {
      company: '365FullPull',
      tagline: 'Vaša destinacija za mobilne igre in aplikacije',
      quickLinks: 'Hitri linki',
      support: 'Podpora',
      legal: 'Pravno',
      contact: 'Kontaktirajte nas',
      address: 'Slovenija',
      email: 'podpora@365fullpull.com',
      rights: 'Vse pravice pridržane.',
      privacy: 'Pravilnik o zasebnosti',
      terms: 'Pogoji uporabe',
      cookies: 'Piškotki',
      home: 'Domov',
      features: 'Funkcije',
      howItWorks: 'Kako deluje',
      games: 'Igre',
      disclaimer: 'Ta storitev vključuje včlanitev v Adsaints. Prejeli boste osebno SMS na spletni strani ali z odgovorom in potrdilom preko SMS se strinjate in potrjujete uporabo storitev kot tudi prejemanje zadnjih najbolj kul mobilnih vsebin (tekstovne vsebine, zvonenja, ozadja, Java igre). Cena storitve je EUR 4,98 na teden (2 SMS tedensko po 2,49 EUR z DDV). Od storitve se lahko odjavite s pošiljanjem Clicksaints STOP NOW na 3838. Vsak teden prejmete 1 novi vsebini. Storitev bo zaračunana na vašem mobilnem računu ali na vašem predplačniškem računu. Vaš aparat mora imeti omogočeno sprejemanje besedilnih sporočil, prenos podatkov in sprejem mobilnih vsebin. Podjetje Clicksaints ni povezano ali sponzorirano s strani proizvajalcev izdelkov, ki so omenjeni ali jih je mogoče videti v tej kampanji. Blagovne znamke, znamke storitev, logotipi (vključno, vendar brez izrecne omejitve na) posamezna imena izdelkov in prodajalcev na drobno so last izvornih lastnikov. Za uporabo storitev morate biti lastnik naročniškega razmerja ali pridobiti izrecno dovoljenje lastnika, v primeru mladoletnosti pa morate pridobiti izrecno dovoljenje staršev ali skrbnikov. Za informacije pokličite 016001850 (Ponedeljek-Petek 09:00-17:00), adsaints.si@silverlines.info. Adsaints B.V., Wim Duisenbergplantsoen 31, 6221 SE, Maastricht, Holland.'
    }
  };

  const t = texts[language];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-blue-400">{t.company}</h3>
            <p className="text-gray-300">{t.tagline}</p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li><a href="#section-1" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">{t.home}</a></li>
              <li><a href="#section-2" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">{t.features}</a></li>
              <li><a href="#section-3" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">{t.howItWorks}</a></li>
              <li><a href="#section-4" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">{t.games}</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.contact}</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-blue-400" />
                <span className="text-gray-300">{t.address}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-400" />
                <span className="text-gray-300">{t.email}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="text-gray-400 text-xs leading-relaxed">
            <p className="mb-4">{t.disclaimer}</p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              <p>© 2024 {t.company}. {t.rights}</p>
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/privacy.html" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 text-sm">
                {t.privacy}
              </a>
              <a href="/terms.html" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 text-sm">
                {t.terms}
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 text-sm">
                {t.cookies}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
